import { LogLevel } from '@azure/msal-browser';
import type { Configuration } from '@azure/msal-browser';

/**
 * Azure AD B2C Configuration
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: 'b94a72c3-966e-40b1-a4f3-ba03f9fd2d10',
    authority: 'https://login.microsoftonline.com/822ef784-771f-4257-9898-e94f265e7eb6',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage for better security
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge support
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * Including the API scope here ensures the user consents to backend API access during login.
 */
export const loginRequest = {
  scopes: ['api://b94a72c3-966e-40b1-a4f3-ba03f9fd2d10/access_as_user'],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API.
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

/**
 * Scopes for your backend API
 * Update this with your actual API scope once you expose an API in Azure
 */
export const apiRequest = {
  scopes: ['api://b94a72c3-966e-40b1-a4f3-ba03f9fd2d10/access_as_user'],
};
